<template>
	<div style="height: 600px; overflow-y: auto; overflow-x: hidden">
		<Row :gutter="10" style="margin-bottom: 20px">

			<Col>
			<div style="margin-left: 30px;">
				<Select placeholder="排序类型" v-model="order_type" @on-change="mySearch">
					<Option value="desc" :key="1">正序 </Option>
					<Option value="asc" :key="2">倒序 </Option>
				</Select>
			</div>
			</Col>
		</Row>
		<Table border :columns="columns" :data="datas">

		</Table>
	</div>
</template>

<script>
	import {
		getSucaiIdCostListByID
	} from "../../../api/advManage.js";
	import {
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		name: "adidData",
		components: {

		},
		props:['timePeriod','timePeriodDate','sucaiID'],
		data() {
			return {
				columns: [
					{
						"title": "序号",
						"type": "index",
						"align": 'center',
						"width":"100px"
					},
					{
						"title": "账户id",
						"key": "account_name",
						"align": 'center',
					},
					{
						"title": "消耗",
						"key": "cost",
						"align": 'center',
					},
				],
				datas: [],
				order_type: 'desc'
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		watch: {
			sucaiID() {
				this.getList();
			},
			timePeriod() {
				this.getList();
			},
		},
		mounted() {
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			mySearch() {
				this.getList();
			},
			async getList() {
				let that = this;
				let data = {}
				data.token = this.token;
				data.sucaiID = that.sucaiID;
				data.timePeriod = that.timePeriod;
				data.timePeriodDate = that.timePeriodDate;
				let res = await getSucaiIdCostListByID(that, data);
				that.datas = res.data.list;
			},
		},
	};
</script>

<style lang="less" scoped>
/deep/ .ivu-table th {
  background: #277dd3;
  color: white;
}
/deep/ .ivu-table .table-blue-row td {
  color: #ff6699;
}
/deep/ .ivu-table .table-yellow-row td {
  color: #aaaa00;
}

/deep/ .ivu-table .table-black-row td {
  color: black;
}
	
</style>
